class Dropdown extends HTMLElement {
  constructor() {
    super();
    this.classList.add('dropdown');
    this.trigger = this.querySelector('.dropdown-btn');
    this.content = this.querySelector('.dropdown-content');
    this.init();
  }

  init() {
    this.trigger.addEventListener('click', () => {
      this.toggleDropdown();
    });

    this.addEventListener('blur', () => {
      this.closeDropdown();
    });

    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) {
        this.closeDropdown();
      }
    });

    // Handle keyboard accessibility
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        this.toggleDropdown();
      } else if (event.key === 'Escape') {
        this.closeDropdown();
      }
    });
  }

  toggleDropdown() {
    const isActive = this.content.classList.contains('active');
    if (isActive) {
      this.closeDropdown();
    } else {
      this.openDropdown();
    }
  }

  openDropdown() {
    this.content.classList.add('active');
    this.trigger.classList.add('active');
  }

  closeDropdown() {
    this.content.classList.remove('active');
    this.trigger.classList.remove('active');
  }
}

if (!customElements.get('drop-down')) {
  customElements.define('drop-down', Dropdown);
}